import { Form, Input, message, Modal, ModalProps } from 'antd';
import FormField from 'components/FormField';
import { Formik } from 'formik';
import { createGroup } from './service';
import { useTranslate } from '@tolgee/react';
import { useEffect, useRef } from 'react';

function GroupForm({
  groupList,
  onSave,
  onCancel,
  ...otherProps
}: ModalProps & {
  groupList: string[];
  onSave: (group: string) => void;
}) {
  const { t } = useTranslate();

  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (otherProps.visible) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 200);
    }
  }, [otherProps.visible]);

  return (
    <Formik
      enableReinitialize
      initialValues={{ group: '' }}
      onSubmit={({ group }, { resetForm }) => {
        return createGroup(group)
          .then(() => {
            message.success(t('phrase.保存成功'));
            onSave(group);
            resetForm();
            onCancel?.({} as any);
          })
          .catch(() => {
            message.error(t('phrase.保存失败，请稍后再试'));
          });
      }}
    >
      {({ isSubmitting, handleSubmit, resetForm }) => {
        return (
          <Modal
            title={t('phrase.添加分组')}
            width={500}
            okText={t('保存')}
            okButtonProps={{
              loading: isSubmitting,
              onClick: () => handleSubmit(),
            }}
            onCancel={(e) => {
              onCancel?.(e);
              resetForm();
            }}
            {...otherProps}
          >
            <Form layout="vertical">
              <FormField<string>
                name="group"
                required
                label={t('phrase.分组名称')}
                validate={(value) => {
                  if (!value.trim()) {
                    return t('department.请输入x', { x: t('phrase.分组名称') });
                  }
                  if (groupList.some((group) => group === value)) {
                    return t('x已存在', { x: t('phrase.分组名称') });
                  }
                }}
              >
                {({ field }) => {
                  return (
                    <Input
                      ref={inputRef}
                      showCount
                      maxLength={30}
                      placeholder={t('department.请输入x', { x: t('phrase.分组名称') })}
                      {...field}
                    />
                  );
                }}
              </FormField>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
}

export default GroupForm;
